// extracted by mini-css-extract-plugin
export default {"hideBtn":"styles_hideBtn__wZMfB","hiddenState":"styles_hiddenState__P2h0H"};